import { LOCALES } from "@/i18n/routing";

export function parseSlug(slugParam: string[] | undefined): string[] {
  if (!slugParam) return ["/"];
  if (LOCALES.includes(slugParam[0] || "")) {
    const rest = slugParam.slice(1);
    return rest.length === 0 ? ["/"] : rest;
  }
  return slugParam.length === 0 ? ["/"] : slugParam;
}
